import { render, staticRenderFns } from "./performAppeal.vue?vue&type=template&id=3e55e2ba&scoped=true&"
import script from "./performAppeal.vue?vue&type=script&lang=js&"
export * from "./performAppeal.vue?vue&type=script&lang=js&"
import style0 from "./performAppeal.vue?vue&type=style&index=0&id=3e55e2ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55e2ba",
  null
  
)

export default component.exports